module.exports = __webpack_public_path__ + "img/mcp.c7c3a78d.svg";